import mySqlToLocal from "./mySqlToLocal"
import dayjs from "dayjs"

const shouldSessionPartialUpdate = (
  sessionStartsAt, 
  sessionEndsAt, 
  openToParents, 
  openToStaff
) => {
  const sessionExpiryDate = mySqlToLocal(sessionEndsAt)
  const hoursSinceExpiry = dayjs().diff(sessionExpiryDate, "hour")
  const hoursToStart = dayjs(sessionStartsAt).diff(dayjs(), "hour")
  const isUpcoming = dayjs().isBefore(sessionStartsAt)
  const isLive = dayjs().isAfter(sessionStartsAt) && dayjs().isBefore(sessionExpiryDate)

  if (isLive) return true;
  if (hoursSinceExpiry >= 0 && hoursSinceExpiry <= 48) return true;
  if (hoursToStart <= 48 && hoursToStart > 0) return true;

  return isUpcoming && (openToParents || openToStaff)
}

export default shouldSessionPartialUpdate